/**
 * Created by: mnicolae
 * Date: 10.07.2017
 */

(function ($) {
    'use strict';

    var ui = kendo.ui,
        Widget = ui.Widget,
        NumericTextBox = ui.NumericTextBox,
        POINT = ".",
        unwrap = TS.unwrap;

    var TsNumericTextBox = NumericTextBox.extend({

        digitsOnlyValue: null,
        inputBehaviour: 1,

        init: function (element, options) {
            var me = this;

            NumericTextBox.fn.init.call(me, element, options);

            if (me.options.inputBehaviour) {
                me.inputBehaviour = me.options.inputBehaviour;
                if (me.inputBehaviour === 2)
                    digitsOnlyValue = me.getDigits(me.value());
            }
        },

        getDigits: function (inputValue) {
            var me = this,
            value = inputValue + '';

            value = value.replace(/\./g, "");
            value = value.replace(/\,/g, "");
            value = parseFloat(value);
            value = value + '';

            return value;
        },

        processKey: function (e) {
            var me = this,
                keys = kendo.keys,
                whichCode = e.which,
                character = '';

            if (whichCode >= 96 && whichCode <= 105)
                whichCode = whichCode - 48;

            character = String.fromCharCode(whichCode);

            if (e != null) {
                if (e.keyCode === keys.TAB)
                    return;
                if (e.keyCode === keys.BACKSPACE || e.keyCode == keys.DELETE) {
                    if (me.digitsOnlyValue.length > 0) {
                        me.digitsOnlyValue = me.digitsOnlyValue.substring(0, me.digitsOnlyValue.length - 1);
                    }
                    //set value here since keypress is not triggered
                    var value = me.formatValue();
                    if (me._numericRegex(me._format(me.options.format)).test(value)) {
                        me._update(value);
                    }
                    e.preventDefault();
                }

                if (!isNaN(character))
                    me.digitsOnlyValue = me.digitsOnlyValue + character;

                console.log(me.digitsOnlyValue);
            }
        },

        formatValue: function () {
            var me = this;

            var l = me.digitsOnlyValue.length;
            var r = parseFloat(me.digitsOnlyValue === '' ? '0' : me.digitsOnlyValue) / Math.pow(10, me.options.decimals);
            r = r + '';
            var padded = r.length >= 5 ? r : new Array(5 - r.length + 1).join('0') + r;

            return padded;
        },

        _keydown: function (e) {
            var me = this;

            if (me.inputBehaviour === 2)
                me.processKey(e);
            NumericTextBox.fn._keydown.call(me, e);
        },

        _keypress: function (e) {
            var keys = kendo.keys,
            caret = kendo.caret;

            if (e.which === 0 || e.metaKey || e.ctrlKey || e.keyCode === keys.BACKSPACE || e.keyCode === keys.ENTER) {
                return;
            }

            var me = this;
            var min = me.options.min;
            var element = me.element;
            var selection = caret(element);
            var selectionStart = selection[0];
            var selectionEnd = selection[1];
            var character = String.fromCharCode(e.which);
            var numberFormat = me._format(me.options.format);
            var isNumPadDecimal = me._key === keys.NUMPAD_DOT;
            var value = element.val();
            var isValid;

            if (isNumPadDecimal) {
                character = numberFormat[POINT];
            }

            if (me.inputBehaviour == 2)
                value = me.formatValue();
            else
                value = value.substring(0, selectionStart) + character + value.substring(selectionEnd);
            isValid = me._numericRegex(numberFormat).test(value);

            if (isValid && me.inputBehaviour == 2) {
                me._update(value);
                e.preventDefault();
            }

            if (isValid && isNumPadDecimal) {
                element.val(value);
                caret(element, selectionStart + character.length);

                e.preventDefault();
            } else if ((min !== null && min >= 0 && value.charAt(0) === "-") || !isValid) {
                e.preventDefault();
            }

            me._key = 0;
        }

    });

    ui.plugin(TsNumericTextBox);

})(jQuery);